import { axios, addHeader } from '@/api/index.js'

const reports = {
  async getIntervalDataCsvFile(nmis, fromDate, toDate, accessToken) {
    return await axios.get(
      '/report/getIntervalDataCsvFile?nmis=' + nmis + '&fromDate=' + fromDate + '&toDate=' + toDate,
      addHeader(accessToken, 15000, 'blob')
    )
  },
  queueIntervalDataRequest: (payload, accessToken) => {
    return axios.post('/report/getQueueIntervalDataRequest', payload, addHeader(accessToken))
  },
}

export default reports
